import QTable from 'quasar/src/components/table/QTable.js';

export function getNewsColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'id',
      field: 'id',
      label: '#',
      align: 'left'
    },
    {
      name: 'title',
      field: 'title',
      label: 'عنوان خبر‌',
      align: 'left'
    },
    {
      name: 'url',
      field: 'url',
      label: 'آدرس خبر',
      align: 'left'
    },
    {
      name: 'image_src',
      field: 'image_src',
      label: 'آدرس تصویر',
      align: 'center'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'تاریخ ایجاد خبر',
      align: 'left'
    },
    {
      name: 'operations',
      field: 'operations',
      label: '',
      align: 'left'
    }
  ]
}


